import React, { Component } from 'react';
import {descCompetences} from '../../models/constantes';
import Reveal from 'react-reveal/Reveal';
import CompetenceItem from './CompetenceItem';
import {styles} from '../common/animation';
import { css } from 'aphrodite';

class Competences extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            selected: "", 
            hover: ""
        }
    }
    
    onMouseOver = (index) => {
        this.setState({hover: index});
    }

    onMouseOut = () => {
		this.setState({hover: ""});
    }
    
    getHoverState = (index) => {
		if(this.state.hover - 1 === index || this.state.hover + 1 === index){
			return css(styles.siblingCompetencePulse);
		} else if(this.state.hover === index) {
			return css(styles.currentCompetencePulse);
		} else if (this.state.hover - 2 === index || this.state.hover + 2 === index){
            return css(styles.cousinsCompetencePulse);
        }
		return "";
    }

    renderElements = (props) => {
        return descCompetences.map((el, index) => {
            
            return ( 
                <Reveal effect={css(styles.fadeIn)} duration={2000}> 
                    <CompetenceItem
                    index={index} 
                    key={el.name} 
                    item={el} 
                    className={this.getHoverState(index)} 
                    onHover={this.onMouseOver} 
                    />
                </Reveal>
            )
        });
    }
    render() {
        return (
            <div className="screen">
                <Reveal effect={css(styles.fadeIn)} duration={2000}> 
                    <h3 className="screen_title">Competences</h3>
                    <p className="screen_description">Vous trouveriez ci-joint l'ensemble des languages, frameworks et libraires que je maîtrise, et que je pratique au quotidien :  </p>
                </Reveal>
                <ul className="wraped_list competences" onMouseOut={this.onMouseOut}>
                {this.renderElements()}
                </ul>
            </div>
        );
    }
}

export default Competences;
/*<p className="competences_list-element-description">{descCompetences[i].desc}</p> */

/*
let vsrc = descCompetences[idex].icon + ".png";
<div key={i} index={i} 
                    className={this.getHoverState(i)} 
                    onHover={this.onMouseOver}
                    >
                        <li className="competences_list-element">
                            <div className="competences_list-element-icon-div"><img className="competences_list-element-icon" src={vsrc}  alt={"logo"} /></div>
                            <h4 className="competences_list-element-title">{descCompetences[i].name}</h4> 
                        </li>
                    </div>

                    */


// WEBPACK FOOTER //
// ./src/components/containers/Competences.js